import React, { useState, useEffect } from 'react';
import { Grid, TextField, Autocomplete, Button, Box } from '@mui/material';
import axios from 'axios';
import { styled } from '@mui/system';
import { matrimoneyEndPoints } from "../../../services/apis";
import {
  getCitiesList,
  getLocationData,
  getReligionsList,
  getCountriesList,
  getCastesList,
  getMusicList,
  getHobbiesList,
  updatePersonalDetails,
  getMotherTongueList,
  getStarList,
  getMoonsignList,
  getInterestsList,
  getCuisineList,
  getReadsList,
  getSportsList,
  getMoviesList,
  getDressStyleList,
  getLanguageList,
  getApplicationForList,
  getSourceList,
  getNearestBranchList,
  getProfileDetails,
  getHealthConditionList,
  getSubCatesList,
  getCitiesListByCountry,
  getStatesListByCountry,
  getDistrictsListByState,
  getCitiessListByDistrict,
  updateNewContactDetails,
  updateNewPrsonalDetails,
  updateNewCostDetails,
  updateNewLifeDetails,
  updateNewCApplicationDetails,
  nearestBranch,
  fetchCastesByReligionId,
  personalCertificatesUpload,
  uploadProfilePic,
  uploadIdProof,
  getEducationList,
  getProfessionList
} from "../../../services/operations/userOperations";
import { StyledFormControl } from '../../common/FormStyles';
import { styles } from '../../styles/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
}));

const smokeOptions = [
  { id: "yes", name: "Yes" },
  { id: "no", name: "No" },
  { id: "occasionally", name: "Occasionally" },
];

const drinkOptions = [
  { id: "yes", name: "Yes" },
  { id: "no", name: "No" },
  { id: "occasionally", name: "Occasionally" },
];

const maritalStatusOptions = [
  { value: 'Single', label: 'UnMarried' },
  { value: 'Divorced', label: 'Divorced' },
  { value: 'Widowed', label: 'Widowed' },
];

const complexions = [
  { id: "VeryFair", name: "Very Fair" },
  { id: "Fair", name: "Fair" },
  { id: "Wheatish", name: "Wheatish" },
  { id: "Dusky", name: "Dusky" },
  { id: "Dark", name: "Dark" },
];

const QuickSearchForm = ({ onSearchComplete }) => {
  const fromAgeOptions = Array.from({ length: 83 }, (_, i) => i + 18);
  let userType = sessionStorage.getItem("userType")
  let token
  if (userType) {
    token = sessionStorage.getItem("token");
  } else {
    token = localStorage.getItem("token");
  }

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [profiledataGet, setProfileDataGet] = useState(null);
  const [educationList, setEducationList] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [motherTongues, setMotherTongues] = useState([]);

  const [formValues, setFormValues] = useState({
    fromAge: "",
    toAge: "",
    fromHeight: "",
    toHeight: "",
    maritalStatus: "",
    country: null,
    state: null,
    city: null,
    education: null,
    profession: null,
    annualIncome: null,
    motherTongue: null,
    smoke: "",
    drink: "",
    complexion: null
  });

  const getToAgeOptions = () => {
    const from = parseInt(formValues.fromAge);
    if (!from) return [];
    return Array.from({ length: 7 }, (_, i) => from + i).filter(age => age <= 100);
  };

  const fetchProfessions = async () => {
    try {
      const response = await getProfessionList();
      if (response.status) {
        setProfessions(response.data);
      }
    } catch (error) {
      console.error("Error fetching professions:", error);
    }
  };

  const fetchMotherTongues = async () => {
    try {
      const response = await getMotherTongueList();
      if (response.status) {
        setMotherTongues(response.data);
      }
    } catch (error) {
      console.error("Error fetching mother tongues:", error);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setIsLoading(true);

        const countriesResponse = await getCountriesList();
        if (countriesResponse.status) {
          setCountries(countriesResponse.data);
        }

        const profileResponse = await getProfileDetails();
        if (profileResponse.status) {
          setProfileDataGet(profileResponse.data);
        }

        const educationResponse = await getEducationList();
        if (educationResponse.status) {
          setEducationList(educationResponse.data);
        }

        await fetchProfessions();

        await fetchMotherTongues();

      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    if (profiledataGet) {
      const initialValues = {
        fromAge: profiledataGet.partnerDetails?.ageFrom || "",
        toAge: profiledataGet.partnerDetails?.ageTo || "",
        fromHeight: profiledataGet.partnerDetails?.heightFrom || "",
        toHeight: profiledataGet.partnerDetails?.heightTo || "",
        // maritalStatus: profiledataGet.customerPersonalDetails?.maritalStatus || "",
        // country: profiledataGet.customerContactDetails?.country || null,
        // state: profiledataGet.customerContactDetails?.state || null,
        // city: profiledataGet.customerContactDetails?.city || null,
        // education: profiledataGet.educationDetails?.education || null,
        // profession: profiledataGet.educationDetails?.profession || null,
        // annualIncome: profiledataGet.jobDetails?.annualIncome || "",
        // motherTongue: profiledataGet.customerPersonalDetails?.motherTongue || null,
        // smoke: profiledataGet.customerLifeDetails?.smoke || "",
        // drink: profiledataGet.customerLifeDetails?.drink || "",
        // complexion: profiledataGet.customerPersonalDetails?.complexion || null
      };

      setFormValues(initialValues);

      if (initialValues.country?.id) {
        fetchStatesListByCountry(initialValues.country.id).then(() => {
          if (initialValues.state?.id) {
            fetchCitiesListByState(initialValues.state.id);
          }
        });
      }
    }
  }, [profiledataGet]);

  const fetchStatesListByCountry = async (countryId) => {
    if (!countryId) return;
    try {
      const response = await getStatesListByCountry(countryId);
      if (response.status) {
        setStates(response.data);
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCitiesListByState = async (stateId) => {
    if (!stateId) return;
    try {
      const response = await getCitiessListByDistrict(stateId);
      if (response.status) {
        setCities(response.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleFieldChange = (name, value) => {
    setFormValues(prev => ({ ...prev, [name]: value }));

    if (name === 'fromAge') {
      setFormValues(prev => ({ ...prev, toAge: "" }));
    }
  };

  const handleCountryChange = (event, value) => {
    setFormValues(prev => ({
      ...prev,
      country: value,
      state: null,
      city: null
    }));
    if (value?.id) {
      fetchStatesListByCountry(value.id);
    } else {
      setStates([]);
      setCities([]);
    }
  };

  const handleStateChange = (event, value) => {
    setFormValues(prev => ({
      ...prev,
      state: value,
      city: null
    }));
    if (value?.id) {
      fetchCitiesListByState(value.id);
    } else {
      setCities([]);
    }
  };

  const handleCityChange = (event, value) => {
    setFormValues(prev => ({ ...prev, city: value }));
  };

  const handleQuickSearch = async () => {
    try {
      setIsLoading(true);

      const payload = {
        fromAge: parseInt(formValues.fromAge) || 0,
        toAge: parseInt(formValues.toAge) || 0,
        fromHeight: parseInt(formValues.fromHeight) || 0,
        toHeight: parseInt(formValues.toHeight) || 0,
        maritalStatus: formValues.maritalStatus || "",
        country: formValues.country?.id || 0,
        state: formValues.state?.id || 0,
        city: formValues.city?.id || 0,
        education: formValues.education?.id || 0,
        profession: formValues.profession?.id || 0,
        // annualIncome: formValues.annualIncome || 0,
        annualIncome: Number(formValues.annualIncome) || 0,
        motherTongue: formValues.motherTongue?.id || 0,
        smoke: formValues.smoke || "",
        drink: formValues.drink || "",
        complexion: formValues.complexion?.id || 0,
        skip: 0,
        limit: 10,
      };

      const response = await axios.post(
        matrimoneyEndPoints.GET_ADVANCED_LIST,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        }
      );

      if (response.data && onSearchComplete) {
        onSearchComplete(response.data.data);
      }
    } catch (error) {
      console.error("Quick search failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <StyledTextField
            select
            label="From Age"
            name="fromAge"
            size="small"
            value={formValues.fromAge}
            onChange={(e) => handleFieldChange('fromAge', e.target.value)}
            fullWidth
            SelectProps={{ native: true }}
            disabled={isLoading}
          >
            <option value=""></option>
            {fromAgeOptions.map((age) => (
              <option key={age} value={age}>
                {age}
              </option>
            ))}
          </StyledTextField>  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <StyledTextField
            select
            label="To Age"
            name="toAge"
            size="small"
            value={formValues.toAge}
            onChange={(e) => handleFieldChange('toAge', e.target.value)}
            fullWidth
            SelectProps={{ native: true }}
            disabled={!formValues.fromAge || isLoading}
          >
            <option value=""></option>
            {getToAgeOptions().map((age) => (
              <option key={age} value={age}>
                {age}
              </option>
            ))}
          </StyledTextField>
        </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <StyledTextField
            type="number"
            label="From Height (cm)"
            name="fromHeight"
            size="small"
            value={formValues.fromHeight}
            onChange={(e) => handleFieldChange('fromHeight', e.target.value)}
            fullWidth
            disabled={isLoading}
          />  </StyledFormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <StyledTextField
            type="number"
            label="To Height (cm)"
            size="small"
            name="toHeight"
            value={formValues.toHeight}
            onChange={(e) => handleFieldChange('toHeight', e.target.value)}
            fullWidth
            disabled={isLoading}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={maritalStatusOptions}
            getOptionLabel={(option) => option.label}
            onChange={(e, value) => handleFieldChange('maritalStatus', value?.value || "")}
            value={
              maritalStatusOptions.find(
                (option) => option.value === formValues.maritalStatus
              ) || null
            }
            renderInput={(params) => (
              <StyledTextField {...params} label="Marital Status" fullWidth size="small"/>
            )}
            disabled={isLoading}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={countries}
            getOptionLabel={(option) => option.countryName || ""}
            onChange={handleCountryChange}
            value={formValues.country}
            renderInput={(params) => (
              <StyledTextField {...params} label="Country" fullWidth size="small"/>
            )}
            disabled={isLoading || countries.length === 0}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={states}
            getOptionLabel={(option) => option.stateName || ""}
            onChange={handleStateChange}
            value={formValues.state}
            renderInput={(params) => (
              <StyledTextField {...params} label="State" fullWidth size="small" />
            )}
            disabled={isLoading || !formValues.country || states.length === 0}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={cities}
            getOptionLabel={(option) => option.cityName || ""}
            onChange={handleCityChange}
            value={formValues.city}
            renderInput={(params) => (
              <StyledTextField {...params} label="City" fullWidth size="small"/>
            )}
            disabled={isLoading || !formValues.state || cities.length === 0}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>

        <StyledFormControl fullWidth size="small">
          <Autocomplete
            options={educationList}
            getOptionLabel={(option) => option.educationName || ""}
            onChange={(e, value) => handleFieldChange('education', value)}
            value={formValues.education}
            renderInput={(params) => (
              <StyledTextField {...params} label="Education" fullWidth size="small"/>
            )}
            disabled={isLoading || educationList.length === 0}
          />
        </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={professions}
            getOptionLabel={(option) => option.professionName || ""}
            onChange={(e, value) => handleFieldChange('profession', value)}
            value={formValues.profession}
            renderInput={(params) => (
              <StyledTextField {...params} label="Profession" fullWidth size="small"/>
            )}
            disabled={isLoading || professions.length === 0}
          />
        </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">
          <StyledTextField
            type="number"
            label="Annual Income"
            name="annualIncome"
            size="small"
            value={formValues.annualIncome}
            onChange={(e) => handleFieldChange('annualIncome', e.target.value)}
            fullWidth
            disabled={isLoading}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={motherTongues}
            getOptionLabel={(option) => option.name || ""}
            onChange={(e, value) => handleFieldChange('motherTongue', value)}
            value={formValues.motherTongue}
            renderInput={(params) => (
              <StyledTextField {...params} label="Mother Tongue" fullWidth size="small"/>
            )}
            disabled={isLoading || motherTongues.length === 0}
          />  </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">
          <Autocomplete
            options={smokeOptions}
            getOptionLabel={(option) => option.name || ""}
            onChange={(e, value) => handleFieldChange('smoke', value?.id || "")}
            value={
              smokeOptions.find((option) => option.id === formValues.smoke) || null
            }
            renderInput={(params) => (
              <StyledTextField {...params} label="Smoke" fullWidth size="small"/>
            )}
            autoHighlight
            openOnFocus
            disabled={isLoading}
          />
        </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={drinkOptions}
            getOptionLabel={(option) => option?.name || ""}
            onChange={(e, value) => handleFieldChange('drink', value?.id || "")}
            value={
              drinkOptions.find(
                (option) => option.id.toString() === formValues.drink?.toString()
              ) || null
            }
            renderInput={(params) => (
              <StyledTextField {...params} label="Drink" fullWidth size="small"/>
            )}
            disabled={isLoading}
            autoHighlight
            openOnFocus
          />
        </StyledFormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <StyledFormControl fullWidth size="small">

          <Autocomplete
            options={complexions}
            getOptionLabel={(option) => option.name || ""}
            onChange={(e, value) => handleFieldChange('complexion', value)}
            value={formValues.complexion}
            renderInput={(params) => (
              <StyledTextField {...params} label="Complexion" fullWidth size="small"/>
            )}
            disabled={isLoading}
          />  </StyledFormControl>
      </Grid>
      <Grid xs={12} md={12}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", gap: "20px", marginTop: "20px" }}>
          <Button
            variant="contained"
            sx={{
              ...styles.searchcancel
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ ...styles.search }}
            onClick={handleQuickSearch}
            disabled={isLoading}
          >
            {isLoading ? 'Searching...' : 'Search'}
          </Button>

        </Box>
      </Grid>
    </Grid>
  );
};

export default QuickSearchForm;